import { render } from "./audit-trail.vue?vue&type=template&id=488ef983&scoped=true"
import script from "./audit-trail.vue?vue&type=script&lang=js"
export * from "./audit-trail.vue?vue&type=script&lang=js"

import "./audit-trail.vue?vue&type=style&index=0&id=488ef983&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488ef983"]])

export default __exports__